export interface Book {
  id: string;
  title: string;
  author: string;
  isbn?: string;
  genre: string;
  status: BookStatus;
  rating?: number; // 1-5 stars
  dateAdded: string;
  dateRead?: string;
  publicationDate?: string; // Publication date/year
  notes?: string;
  coverUrl?: string;
  coverImageFile?: File; // For upload functionality
  pageCount?: number;
  tags: string[];
  position_slot?: string; // Position slot for organization
  // Favorites functionality
  isFavorite?: boolean;
  favoriteNotes?: string;
  favoritedAt?: string;
  // Reading progress functionality
  currentPage?: number; // Current page the user is on
  readingProgress?: number; // Progress percentage (0-100)
  totalPages?: number; // Total pages (may differ from pageCount)
  readingStatus?: 'not_started' | 'reading' | 'completed' | 'paused' | 'abandoned';
  // Properties for storing metadata (e.g., linkedNoteId)
  properties?: { [key: string]: any };
}

export enum BookStatus {
  WANT_TO_READ = 'want_to_read',
  CURRENTLY_READING = 'currently_reading',
  READ = 'read',
  DNF = 'did_not_finish' // Did Not Finish
}

export interface BookFilters {
  status?: BookStatus;
  genre?: string;
  rating?: number;
  searchQuery?: string;
  position_slot?: string;
  // Backend filtering support
  author?: string;
  subject?: string;
  language?: string;
  publication_year?: string;
  minRating?: number;
  // Sorting options
  sortBy?: 'title' | 'author' | 'dateAdded' | 'rating' | 'position_slot' | 'publicationDate';
  sortOrder?: 'asc' | 'desc';
}

export interface BookFormData {
  title: string;
  author: string;
  isbn?: string;
  genre: string;
  status: BookStatus;
  rating?: number;
  notes?: string;
  coverUrl?: string;
  coverImageFile?: File;
  pageCount?: number;
  tags: string[];
  position_slot?: string;
  currentPage?: number;
  totalPages?: number;
}